import axios from 'axios';
import ComercialTabla from '../types/ComercialTabla';

async function InsertarAgenteComercial(ComercialNuevo: ComercialTabla) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/insertar_comercial"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "comercial": {
                    "cuit": ComercialNuevo.cuit,
                    "codigo": ComercialNuevo.codigo,
                    "apellido": ComercialNuevo.apellido,
                    "nombres": ComercialNuevo.nombres,
                    "nombrefan": ComercialNuevo.nombrefantasia,
                    "domicilio": ComercialNuevo.domicilio,
                    "telefono": ComercialNuevo.telefono,
                    "celular": ComercialNuevo.celular,
                    "email": ComercialNuevo.email,
                    "habilitado": ComercialNuevo.habilitado,
                    "idpais": ComercialNuevo.idpais,
                    "idprovincia": ComercialNuevo.idprovincia,
                    "idlocalidad": ComercialNuevo.idlocalidad,
                    "codpostal": ComercialNuevo.codpostal,
                    "observaciones": ComercialNuevo.observaciones
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default InsertarAgenteComercial;